import { Guid } from "client_legacy/ndaw/guid";
import { userDatabaseMigrator, USER_DATABASE_VERSION } from "./Migrations";
import { UserDatabaseSession, IUserDatabaseSession } from "./session";
import { ensureNotNil } from "client/Misc/utils";

export interface IEnvironmentDatabase {
	openForCurrentUser(): Promise<IUserDatabaseSession>;
	open(userId: number): Promise<IUserDatabaseSession>;
}

export class EnvironmentDatabase implements IEnvironmentDatabase {
	private readonly _environmentId: Guid;
	private readonly _currentUserId: number;

	constructor(environmentId: Guid, currentUserId: number) {
		this._environmentId = environmentId;
		this._currentUserId = currentUserId;
	}

	public async open(userId: number): Promise<IUserDatabaseSession> {
		if (!indexedDB) {
			throw new Error("Database API is not supported");
		}

		const databaseName = `Environment__${this._environmentId}`;

		const database: IDBDatabase = await this.openAndMigrateDatabaseInternal(databaseName);

		return new UserDatabaseSession(database, userId);
	}

	public openForCurrentUser(): Promise<IUserDatabaseSession> {
		return this.open(this._currentUserId);
	}

	private openAndMigrateDatabaseInternal(databaseName: string): Promise<IDBDatabase> {
		return new Promise<IDBDatabase>((resolve, reject) => {
			const request: IDBOpenDBRequest = indexedDB.open(databaseName, USER_DATABASE_VERSION);

			request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
				const isDatabaseBeingDeleted = event.newVersion === null;
				if (isDatabaseBeingDeleted) {
					return;
				}

				const target = event.currentTarget as IDBOpenDBRequest;

				const database: IDBDatabase = target.result;
				const transaction: IDBTransaction = ensureNotNil(target.transaction);

				userDatabaseMigrator.migrate(
					database,
					transaction,
					event.oldVersion,
					event.newVersion
				);
			};

			request.onsuccess = (): void => {
				resolve(request.result);
			};
			request.onerror = () => void reject(request.error);
			request.onblocked = () => void reject("Transaction blocked");
		});
	}
}